import React from "react";
import IPick_List_Catalog_Item_Detail from "../../../models/IPick_List_Catalog_Item_Detail";
import IssueReasonEnum from "../../../models/IssueReasonEnum";
import StatusEnum from "../../../models/StatusEnum";

type Props = {
    item: IPick_List_Catalog_Item_Detail;
};

export const OwItemPickStatus: React.FC<Props> = (props) => {
    let icon = "fa-lg far fa-circle";

    if (props.item.Pick_List_Catalog_Item_Map.status_id === StatusEnum.PARTIAL) {
        icon = "fa-lg fas fa-adjust text-warning";
    } else if (props.item.Pick_List_Catalog_Item_Map.status_id === StatusEnum.COMPLETED) {
        icon = "fa-lg fas fa-check-circle text-success";
    }

    if (props.item.Pick_List_Catalog_Item_Map.issue_reason_id === IssueReasonEnum.INSUFFICIENT_QTY) {
        if (props.item.Pick_List_Catalog_Item_Map.qty_to_pick === props.item.Pick_List_Catalog_Item_Map.issue_qty) {
            icon = "fa-lg fas fa-times-circle text-danger";
        }
    }

    return (
        <div className={"OwItemPickStatus"}>
            <i data-testid={"pick-status-icon"} className={icon} />
        </div>
    );
};
